import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Mi Historia',
    href: '#historia'
  }, {
    name: 'Productos',
    href: '#productos'
  }, {
    name: 'Glow Up',
    href: '#glowup'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-cream/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-140" data-mp="9iqb1zn1xsk8">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-141" data-mp="1kyeyst84qvm3">
        <a href="#" className="text-2xl md:text-3xl font-serif font-semibold text-brand-charcoal tracking-wide text-shimmer" data-id="element-142" data-mp="9nfx4j1zn6tf">
          nicolskincare
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-143" data-mp="jmdt271qu2mg">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-charcoal/80 hover:text-brand-rose-dark transition-colors" data-id="element-144" data-mp="olgnyyo0esgp">
              {link.name}
            </a>)}
          <a href="#productos" className="btn-sparkle px-5 py-2 bg-brand-sage text-white text-sm font-medium rounded-full hover:bg-brand-sage-dark transition-colors soft-glow-hover" data-id="element-145" data-mp="3s2gsxqmm6n08">
            🛒 Comprar
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-brand-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-146" data-mp="5o779pa2jt35">
          {isMobileMenuOpen ? <X size={24} data-id="element-147" data-mp="39axodfcxz0w3" /> : <Menu size={24} data-id="element-148" data-mp="39ao66dy51y0y" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-149" data-mp="31a85d94d0f1s">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-brand-cream border-t border-brand-beige shadow-lg md:hidden" data-id="element-150" data-mp="3196x1ceqa6nr">
            <nav className="flex flex-col px-6 py-4 gap-4" data-id="element-151" data-mp="3642z75doiael">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg text-brand-charcoal/80 hover:text-brand-rose-dark py-2 border-b border-brand-beige/50" data-id="element-152" data-mp="2icxhsls3ba26">
                  {link.name}
                </a>)}
              <a href="#productos" onClick={() => setIsMobileMenuOpen(false)} className="btn-sparkle mt-2 px-5 py-3 bg-brand-sage text-white text-center font-medium rounded-full hover:bg-brand-sage-dark transition-colors soft-glow" data-id="element-153" data-mp="2nbs3bvhfzcpz">
                🛒 Comprar
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}